const documentElement = document.documentElement;
let isTekcloud;
	
function darkModeListener(event) {
	if (event.matches) {
		// this dark mode
		documentElement.classList.add('dark');
	} else {
		// this is not dark mode
		documentElement.classList.remove('dark');
	}
};

export const osTheme = {
	inserted(el, binding) {
		isTekcloud = binding.value;	
		if (isTekcloud) {
			if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
				documentElement.classList.add('dark');
			}

			window
				.matchMedia('(prefers-color-scheme: dark)')
				.addEventListener('change', darkModeListener);
		}
	},
	unbind(){
		if (isTekcloud) {
			window.removeEventListener('change', darkModeListener);
		}
	}
};



// WEBPACK FOOTER //
// ./src/directives/os-theme.js